import { render, staticRenderFns } from "./BaseRatePlan.vue?vue&type=template&id=adf366de"
import script from "./BaseRatePlan.vue?vue&type=script&lang=js"
export * from "./BaseRatePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports